import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

/*
 * Every SMS the practice has sent, for the global Communications page. The whole list is
 * fetched rather than `/smsmessage/page` so the table's own search covers all messages
 * and not just the page on screen.
 */
export const usePracticeSmsHistory = () => {
  const tenantVal = localStorage.getItem("kinesin-tenant") ?? "";

  return useQuery({
    queryKey: ["practiceSmsHistory", tenantVal],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(`${tenantVal}/smsmessage`);

      return response.data;
    },
    enabled: !!tenantVal,
  });
};
